/* ============================================================================
   Peanutshell Enhanced PDP — AOV module behaviours (demo build)
   - Module 1: quantity tiers set the real ATC quantity on the product form
   - Module 3: gift wrap + message attach as line-item properties on the form
   - Module 2: "Complete the look" multi-adds selected items to the cart
   - Module 4: unlock-discount nudge reads /cart.js and updates on cart:refresh
   No framework; safe no-ops if an element isn't present.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__aovPdpInit) return;
  window.__aovPdpInit = true;

  // QA 2026-07-23: Eurus's Alpine add-to-cart serializes the form(s) marked
  // x-ref="product_form" (main buy box AND sticky bar). Other /cart/add forms
  // on the page (apps, installments) are never submitted — injecting the tier
  // quantity into those was why 2/3-packs added qty 1.
  function productForms() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    var refs = forms.filter(function (f) {
      return f.getAttribute('x-ref') === 'product_form' && f.querySelector('[name="id"]');
    });
    if (refs.length) return refs;
    return forms.filter(function (f) { return f.querySelector('[name="id"]'); });
  }

  function mainProductForm() {
    return productForms()[0] || null;
  }

  function setQuantityOnForms(qty) {
    productForms().forEach(function (form) {
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput) {
        qtyInput = document.createElement('input');
        qtyInput.type = 'hidden';
        qtyInput.name = 'quantity';
        qtyInput.setAttribute('data-aov-qty', '');
        form.appendChild(qtyInput);
      }
      qtyInput.value = qty;
      qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2);
    return '$' + n;
  }

  // --------------------------------------------------------------------------
  // Module 1 — Stock up (quantity tiers + mix & match across sibling prints)
  // --------------------------------------------------------------------------
  function initTiers() {
    var wrap = document.querySelector('[data-aov-tiers]');
    if (!wrap) return;

    var mix = document.querySelector('[data-aov-mix]');
    var mixSlots = mix ? mix.querySelector('[data-aov-mix-slots]') : null;
    var currentHandle = mix ? mix.getAttribute('data-current-handle') : '';
    var family = [];
    var dataEl = document.querySelector('[data-aov-mix-data]');
    if (dataEl) {
      try { family = JSON.parse(dataEl.textContent); } catch (e) { family = []; }
    }
    var canMix = mix && mixSlots && family.length > 1;
    var currentQty = 1;

    function famByHandle(h) {
      for (var i = 0; i < family.length; i++) if (family[i].handle === h) return family[i];
      return null;
    }

    function buildSlots(qty) {
      if (!canMix) return;
      if (qty < 2) { mix.hidden = true; mixSlots.innerHTML = ''; return; }
      mix.hidden = false;
      mixSlots.innerHTML = '';
      for (var i = 1; i <= qty; i++) {
        var row = document.createElement('div');
        row.className = 'aov-mix__row';
        var lab = document.createElement('span');
        lab.className = 'aov-mix__lab';
        lab.textContent = 'Pack ' + i;
        var sel = document.createElement('select');
        sel.className = 'aov-mix__select';
        sel.setAttribute('data-aov-mix-slot', '');
        sel.setAttribute('aria-label', 'Print for pack ' + i);
        family.forEach(function (m) {
          var o = document.createElement('option');
          o.value = m.handle;
          o.textContent = m.title;
          if (m.handle === currentHandle) o.selected = true;
          sel.appendChild(o);
        });
        row.appendChild(lab);
        row.appendChild(sel);
        mixSlots.appendChild(row);
      }
    }

    function slotSelections() {
      if (!canMix || currentQty < 2) return [];
      return Array.prototype.slice.call(mixSlots.querySelectorAll('[data-aov-mix-slot]'))
        .map(function (s) { return s.value; });
    }

    function isMixed() {
      var slots = slotSelections();
      return slots.length > 1 && slots.some(function (h) { return h !== currentHandle; });
    }

    // Resolve the size (option1) chosen in the main form, then pick each
    // sibling's variant of the same size; fall back to its first available.
    function resolveVariantId(member, sizeName) {
      var v = null;
      if (sizeName) {
        v = member.variants.filter(function (x) { return x.o1 === sizeName && x.avail; })[0];
      }
      if (!v) v = member.variants.filter(function (x) { return x.avail; })[0];
      if (!v) v = member.variants[0];
      return v ? v.id : null;
    }

    function doMixedAdd(form, button) {
      var idInput = form.querySelector('[name="id"]');
      var cur = famByHandle(currentHandle);
      var sizeName = null;
      if (cur && idInput) {
        cur.variants.forEach(function (v) {
          if (String(v.id) === String(idInput.value)) sizeName = v.o1;
        });
      }
      var counts = {};
      slotSelections().forEach(function (h) {
        var member = famByHandle(h);
        if (!member) return;
        var vid = resolveVariantId(member, sizeName);
        if (!vid) return;
        counts[vid] = (counts[vid] || 0) + 1;
      });
      var items = Object.keys(counts).map(function (vid) {
        return { id: parseInt(vid, 10), quantity: counts[vid] };
      });
      if (!items.length) return;

      var originalText = button ? button.textContent : '';
      if (button) { button.disabled = true; button.textContent = 'Adding\u2026'; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (window.PeanutCart && typeof window.PeanutCart.open === 'function') {
            window.PeanutCart.open();
          }
        })
        .finally(function () {
          if (button) {
            setTimeout(function () { button.disabled = false; button.textContent = originalText; }, 1200);
          }
        });
    }

    // Capture-phase intercept: when prints are mixed, the native single-product
    // submit (Eurus Alpine) must not run — we add the combination ourselves.
    document.addEventListener('click', function (e) {
      if (!isMixed()) return;
      var button = e.target.closest('button[type="submit"], button[name="add"], [data-atc-button]');
      if (!button) return;
      var form = button.closest('form[action*="/cart/add"]');
      if (!form || productForms().indexOf(form) === -1) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      doMixedAdd(form, button);
    }, true);

    wrap.addEventListener('click', function (e) {
      var tier = e.target.closest('[data-aov-tier]');
      if (!tier) return;
      e.preventDefault();
      var qty = parseInt(tier.getAttribute('data-aov-tier'), 10) || 1;
      currentQty = qty;
      wrap.querySelectorAll('[data-aov-tier]').forEach(function (t) {
        t.classList.toggle('is-selected', t === tier);
        t.setAttribute('aria-pressed', t === tier ? 'true' : 'false');
      });
      // Apply to ALL real product forms (main buy box + sticky bar) so the
      // tier quantity survives whichever ATC the shopper clicks. When prints
      // are mixed the intercept above takes over and this qty is ignored.
      setQuantityOnForms(qty);
      buildSlots(qty);
    });
  }

  // --------------------------------------------------------------------------
  // Module 3 — Make it a gift (line-item properties synced into the form)
  // --------------------------------------------------------------------------
  function setFormProp(form, name, value) {
    if (!form) return;
    var selector = 'input[type="hidden"][data-aov-prop="' + name + '"]';
    var input = form.querySelector(selector);
    if (value === null) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.setAttribute('data-aov-prop', name);
      form.appendChild(input);
    }
    input.value = value;
  }

  function initGift() {
    var gift = document.querySelector('[data-aov-gift]');
    if (!gift) return;
    var form = mainProductForm();
    var wrap = gift.querySelector('[data-aov-giftwrap]');
    var toggle = gift.querySelector('[data-aov-giftmsg-toggle]');
    var msg = gift.querySelector('[data-aov-giftmsg]');

    if (wrap) {
      wrap.addEventListener('change', function () {
        setFormProp(mainProductForm(), 'Gift wrap', wrap.checked ? 'Yes (+$4.99)' : null);
      });
    }
    if (toggle && msg) {
      toggle.addEventListener('change', function () {
        msg.classList.toggle('is-visible', toggle.checked);
        if (!toggle.checked) setFormProp(mainProductForm(), 'Gift message', null);
      });
    }
    if (msg) {
      msg.addEventListener('input', function () {
        setFormProp(mainProductForm(), 'Gift message', msg.value ? msg.value : null);
      });
    }
  }

  // --------------------------------------------------------------------------
  // Module 2 — Complete the look (multi-add)
  // --------------------------------------------------------------------------
  function initCompleteTheLook() {
    var root = document.querySelector('[data-aov-cts]');
    if (!root) return;
    var addBtn = root.querySelector('[data-aov-cts-add]');
    if (!addBtn) return;
    var savingsPct = parseInt(root.getAttribute('data-aov-cts-savings'), 10) || 0;

    function selectedItems() {
      return Array.prototype.slice
        .call(root.querySelectorAll('[data-aov-cts-item]:checked'))
        .map(function (cb) { return { id: parseInt(cb.value, 10), quantity: 1 }; })
        .filter(function (i) { return i.id; });
    }

    // CTA reflects the selection AND the store's tiered automatic discounts:
    // 2 eligible items -> 10% off, 3+ -> 15% off (Shopify applies the better
    // one). Math mirrors checkout: discount floored per unit, then summed.
    function tierPercent(count) {
      if (savingsPct > 0) return savingsPct; // explicit section override wins
      if (count >= 3) return 15;
      if (count === 2) return 10;
      return 0;
    }

    function updateCta() {
      var checked = Array.prototype.slice.call(root.querySelectorAll('[data-aov-cts-item]:checked'));
      if (!checked.length) {
        addBtn.disabled = true;
        addBtn.textContent = 'Select items to bundle';
        return;
      }
      addBtn.disabled = false;
      var pct = tierPercent(checked.length);
      var deal = checked.reduce(function (sum, cb) {
        var price = parseInt(cb.getAttribute('data-price'), 10) || 0;
        return sum + (price - Math.floor(price * pct / 100));
      }, 0);
      var label = 'Add ' + checked.length + ' item' + (checked.length > 1 ? 's' : '');
      if (pct > 0) label += ' \u00B7 save ' + pct + '%';
      addBtn.textContent = label + ' (' + money(deal) + ')';
    }

    root.addEventListener('change', function (e) {
      if (!e.target.closest('[data-aov-cts-item]')) return;
      updateCta();
    });
    updateCta();

    // ML-powered picks via Shopify's Product Recommendations API (skipped when
    // the merchant curated items with the custom.set_items metafield).
    function renderMlItems(products) {
      var grid = root.querySelector('.aov-cts__grid');
      if (!grid) return;
      var html = '';
      products.forEach(function (p) {
        var v = null;
        for (var i = 0; i < (p.variants || []).length; i++) {
          if (p.variants[i].available) { v = p.variants[i]; break; }
        }
        if (!v) return;
        var img = p.featured_image || '';
        if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=120';
        var title = (p.title || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
        html += '<label class="aov-cts__item">' +
          '<input class="aov-cts__check" type="checkbox" data-aov-cts-item value="' + v.id + '" data-price="' + p.price + '" checked>' +
          (img ? '<img class="aov-cts__img" src="' + img + '" alt="' + title + '" loading="lazy" width="56" height="56">' : '<span class="aov-cts__img"></span>') +
          '<span class="aov-cts__meta">' +
          '<a class="aov-cts__name" href="' + p.url + '">' + title + '</a>' +
          '<span class="aov-cts__price">' + money(p.price) + '</span>' +
          '</span></label>';
      });
      if (!html) return;
      grid.innerHTML = html;
      updateCta();
    }

    function fetchRecs(productId, intent) {
      return fetch('/recommendations/products.js?product_id=' + productId + '&limit=6&intent=' + intent, {
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          return (d.products || []).filter(function (p) {
            return String(p.id) !== String(productId) && p.available;
          });
        })
        .catch(function () { return []; });
    }

    var mlProductId = root.getAttribute('data-aov-cts-product');
    if (root.hasAttribute('data-aov-cts-ml') && mlProductId) {
      fetchRecs(mlProductId, 'complementary').then(function (recs) {
        if (recs.length >= 2) return recs;
        return fetchRecs(mlProductId, 'related');
      }).then(function (recs) {
        if (recs.length >= 2) renderMlItems(recs.slice(0, 3));
        // fewer than 2 ML picks: keep the server-rendered fallback items
      });
    }

    addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var items = selectedItems();
      if (!items.length) return;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          // cart-drawer.js patches fetch to detect /cart/add and open the drawer.
          if (window.PeanutCart && typeof window.PeanutCart.open === 'function') {
            window.PeanutCart.open();
          }
          addBtn.textContent = 'Added';
          setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 1500);
        })
        .catch(function () {
          addBtn.textContent = original;
          addBtn.disabled = false;
        });
    });
  }

  // --------------------------------------------------------------------------
  // Module 4 — Unlock discount nudge
  // --------------------------------------------------------------------------
  function initUnlockNudge() {
    var nudge = document.querySelector('[data-aov-unlock]');
    if (!nudge) return;
    var threshold = parseInt(nudge.getAttribute('data-threshold'), 10) || 5000;
    var percent = parseInt(nudge.getAttribute('data-percent'), 10) || 15;
    var labelEl = nudge.querySelector('[data-aov-unlock-label]');
    var fillEl = nudge.querySelector('[data-aov-unlock-fill]');

    function render(total) {
      var pct = Math.max(0, Math.min(100, Math.round((total / threshold) * 100)));
      if (fillEl) fillEl.style.width = pct + '%';
      var unlocked = total >= threshold;
      nudge.classList.toggle('is-unlocked', unlocked);
      if (!labelEl) return;
      if (unlocked) {
        labelEl.innerHTML = 'You unlocked <strong>' + percent + '% off</strong>';
      } else {
        var remaining = threshold - total;
        labelEl.innerHTML = money(total) + ' of ' + money(threshold) +
          ' — add <strong>' + money(remaining) + '</strong> to save ' + percent + '%';
      }
    }

    function refresh() {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { render(cart.total_price || 0); })
        .catch(function () {});
    }

    refresh();
    document.addEventListener('cart:refresh', function (e) {
      if (e && e.detail && e.detail.cart) { render(e.detail.cart.total_price || 0); }
      else { refresh(); }
    });
  }

  // --------------------------------------------------------------------------
  // Delivery ETA filler (today + 4 days, brand-friendly relative copy)
  // --------------------------------------------------------------------------
  function initDelivery() {
    var el = document.querySelector('[data-aov-delivery]');
    if (!el) return;
    var d = new Date();
    d.setDate(d.getDate() + 4);
    try {
      el.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) { /* leave fallback copy */ }
  }

  function init() {
    initTiers();
    initGift();
    initCompleteTheLook();
    initUnlockNudge();
    initDelivery();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
